(function () {
  function init(root) {
    if (!root || root.dataset.nfRvReady === 'true') return;
    var track = root.querySelector('.pdp-testimonials__track');
    var prev = root.querySelector('.nf-rv-prev');
    var next = root.querySelector('.nf-rv-next');
    var dotsWrap = root.querySelector('.nf-rv-dots');
    if (!track || !prev || !next || !dotsWrap) return;
    var slides = track.querySelectorAll('.pdp-testimonials__slide');
    if (!slides.length) return;
    root.dataset.nfRvReady = 'true';
    var dots = [];
    function step() { var a = slides[0], b = slides[1]; return b ? b.offsetLeft - a.offsetLeft : track.clientWidth; }
    function visible() { return Math.max(1, Math.round(track.clientWidth / step())); }
    function pages() { return Math.ceil(slides.length / visible()); }
    function update() {
      var end = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
      var i = end ? dots.length - 1 : Math.round(track.scrollLeft / (visible() * step()));
      dots.forEach(function (d, j) { d.setAttribute('aria-current', j === i ? 'true' : 'false'); });
      prev.disabled = track.scrollLeft < 4;
      next.disabled = end;
    }
    function build() {
      dotsWrap.innerHTML = '';
      dots = [];
      for (var i = 0; i < pages(); i++) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'nf-rv-dot';
        b.setAttribute('aria-label', 'Review page ' + (i + 1));
        (function (n) { b.addEventListener('click', function () { track.scrollTo({ left: n * visible() * step(), behavior: 'smooth' }); }); })(i);
        dotsWrap.appendChild(b);
        dots.push(b);
      }
      update();
    }
    prev.addEventListener('click', function () { track.scrollBy({ left: -visible() * step(), behavior: 'smooth' }); });
    next.addEventListener('click', function () { track.scrollBy({ left: visible() * step(), behavior: 'smooth' }); });
    var raf;
    track.addEventListener('scroll', function () { cancelAnimationFrame(raf); raf = requestAnimationFrame(update); }, { passive: true });
    var rt;
    window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(build, 150); });
    build();
  }
  function initAll() { document.querySelectorAll('.nf-rv-carousel').forEach(init); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', initAll); } else { initAll(); }
  document.addEventListener('shopify:section:load', function (e) { var r = e.target.querySelector('.nf-rv-carousel'); if (r) init(r); });
})();
